import React, { useState, useEffect } from 'react';
import "../Konnect2022/konnect2022.css";
import CompaniesLogo from '../../../../../UI/Companies-Logo/CompaniesLogo';
import EventGallery from '../../../EventGallery';
import Image1 from "../../../../../../assets/gallery/i1.webp";
import Image2 from "../../../../../../assets/gallery/i2.webp";
import Image3 from "../../../../../../assets/gallery/i3.webp";
import Image4 from "../../../../../../assets/gallery/i4.webp";
import Image5 from "../../../../../../assets/gallery/i5.webp";
import Target from "../../../../../../assets/konnect/target.gif";
import Hotel from "../../../../../../assets/konnect/hotel.gif";
import Meeting from "../../../../../../assets/konnect/meeting.gif";
import Airoplane from "../../../../../../assets/konnect/airoplane.gif";
import Decision from "../../../../../../assets/konnect/decision.gif";
import Statistic from "../../../../../../assets/konnect/statistic.gif";

// Animated Stat Component
const AnimatedStat = ({ value, label }) => {
  const [count, setCount] = useState(0);
  const ref = React.useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          const duration = 2000;
          const startTime = performance.now();

          const animate = (time) => {
            const progress = Math.min((time - startTime) / duration, 1);
            setCount(Math.floor(progress * value));
            if (progress < 1) requestAnimationFrame(animate);
          };

          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value, hasAnimated]);

  return (
    <div className="stat-card  d-flex flex-column align-items-center justify-content-center text-center" ref={ref}>
      <span className="stat-number text-center justify-center">{count.toLocaleString()}+</span>
      <p className='fs-3 text-center'>{label}</p>
    </div>
  );
};

// Feature Video Hero Section
const HeroVideo = ({ videoUrl, isMuted, toggleSound }) => {
  const iframeRef = React.useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const message = isMuted
      ? '{"event":"command","func":"mute","args":""}'
      : '{"event":"command","func":"unMute","args":""}';

    iframe.contentWindow.postMessage(message, "*");
  }, [isMuted]);

  return (
    <div className="hero-video-wrapper">
      <iframe
        ref={iframeRef}
        className="full-bg-video"
          src="https://www.youtube.com/embed/VJVsDSw1Yfw?autoplay=1&mute=1&loop=1&playlist=VJVsDSw1Yfw&controls=0&modestbranding=1&rel=0&enablejsapi=1"
        title="IHN Konnect 2023 Highlights"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
       <div className="hero-overlay-content">
      <div className="text-card-bottom">
        <h2 className="fade-in-line">
          <span className="hero-title-tag">Konnect 2022 :</span>
          <span className="hero-desc-tag">29th June 2022 | The Leela Ambience Convention Hotel | Delhi</span>
        </h2>
      </div>
      </div>
      <button className="sound-toggle-btn" onClick={toggleSound}>
        {isMuted ? "🔇" : "🔊"}
      </button>
      
    </div>
  );
};

export default function Konnect2022() {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const konnect2022Event = {
    title: "IHN Konnect 2022",
    gallery: [Image1, Image2, Image3, Image4, Image5],
    videoUrl: "https://www.youtube.com/embed/YOUR_KONNECT2022_VIDEO_ID"
  };

  const toggleSound = () => setIsMuted(!isMuted);

  return (
    <div className="konnect-container">

      {/* Hero Video Section */}
      <section className="hero-section">
        <HeroVideo videoUrl={konnect2022Event.videoUrl} isMuted={isMuted} toggleSound={toggleSound} />
      </section>

      {/* Stats Section */}
      <section className="stats-grid ">
        <AnimatedStat value={41} label="Global Sellers" />
        <AnimatedStat value={200} label="Premium Buyers" />
        <AnimatedStat value={5000} label="Successful Meetings" />
      </section>

      {/* About Konnect 2022 */}
      <section className="konnect-about my-5">
        <div className="konnect-about-container">
          <h1 className="heading text-center">
            About IHN Konnect 2022
          </h1>

          <p className="text-center text-light fs-4 align-justify">
            IHN Konnect 2022 was a <strong>flagship B2B networking event</strong> designed for hospitality, travel, tourism, MICE, and luxury travel professionals, delivering measurable business outcomes through curated access and structured engagement.
          </p>

          <p className="text-center text-light fs-4 align-justify">
            Bringing together <span className="konnect-highlight">450+ verified buyers</span> and <span className="konnect-highlight">60+ global sellers</span> from across India and international markets, the event connected top decision-makers including CXOs, Owners, Sales & Revenue Heads, representing hotels, resorts, airlines, cruise lines, tourism boards, and event companies.
          </p>

          <p className="text-center text-light fs-4 align-justify">
            Using IHN’s <span className="konnect-highlight">Curated Networking Format</span>, Konnect 2022 facilitated <span className="konnect-highlight">10,000+ structured one-on-one B2B meetings</span>, enabling faster deal discovery, partnership alignment, and pipeline generation for all participants.
          </p>
        </div>
      </section>

      {/* Key Highlights Section */}
      <section className="highlights-section">
        <h1 className="heading text-center pb-3">Key Highlights</h1>
        <div className="highlights-grid container">
          {[
            { image: Target, text: "450+ pre-qualified B2B delegates" },
            { image: Airoplane, text: "India-focused with international reach" },
            { image: Meeting, text: "10,000+ structured one-on-one meetings" },
            { image: Hotel, text: "Hospitality, travel, MICE & luxury segments covered" },
            { image: Decision, text: "Invite-only, decision-maker-led participation" },
            { image: Statistic, text: "High buyer-to-seller conversion focus" }
          ].map((item, index) => (
            <div className="highlight-card" key={index}>
              <div className="highlight-icon">
                <img src={item.image} alt={item.text} className='highlight-image' />
              </div>
              <h4>{item.text}</h4>
            </div>
          ))}
        </div>

        {/* View Gallery Button Below Video */}
        <div className="text-center mt-4">
          <button
            className="btn-primary"
            onClick={() => setIsGalleryOpen(true)}
          >
            View Gallery
          </button>
        </div>
      </section>

      {/* Companies Section */}
      <section className="companies-section">
        <CompaniesLogo />
      </section>

      {/* Event Gallery */}
      <EventGallery
        isOpen={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        event={konnect2022Event}
      />
    </div>
  );
}
